import React, { useState, useEffect } from "react";
import Link from "react-router-dom/Link";
import {
  Button,
  Collapse,
  Dropdown,
  ProgressBar,
  InputGroup,
  Form,
} from "react-bootstrap";
import { SlideToggle } from "react-slide-toggle";

import menuData from "../../utils/data/menu.json";
import { propTypes } from "react-bootstrap/esm/Image";

export default function Header(props) {
  const [showUserBox, toggleUserBox] = useState(false);
  const [menu, toggleMenu] = useState(false);
  const [search, toggleSearch] = useState(false);

  useEffect(() => {
    document.querySelector("body").addEventListener("click", onBodyClick);
  }, []);

  function onToggleUserBox(e) {
    e.preventDefault();
    toggleUserBox(!showUserBox);
  }

  function onBodyClick(e) {
    if (!e.target.closest(".userbox")) {
      toggleUserBox(false);
    }
  }

  function prevent(e) {
    e.preventDefault();
  }

  return (
    <header className="header header-nav-menu header-nav-links">
      <div className="logo-container" style={{ textAlign: "right" }}>
        <Link
          to={"./"}
          className="logo"
          style={{ right: "150px", left: "initial" }}
        >
          <img
            src={`/assets/images/Logo.png`}
            className="logo-image"
            width="90"
            height="auto"
            alt="Porto Admin"
            style={{
              marginTop: "-10px",
              width: "50px",
              position: "relative",
              left: "40px",
            }}
          />
          <img
            src={`/assets/images/Logo.png`}
            className="logo-image-mobile"
            width="90"
            height="auto"
            alt="Porto Admin"
            style={{ marginTop: "-10px" }}
          />
        </Link>
        <Button
          variant=""
          className="header-btn-collapse-nav d-md-none"
          onClick={() => toggleMenu(!menu)}
        >
          <i className="fas fa-bars"></i>
        </Button>

        <Collapse in={menu}>
          <div className="header-nav d-md-none">
            <div className="header-nav-main header-nav-main-effect-1 header-nab-main-sub-effect-1 header-nav-main-square">
              <nav>
                <ul className="nav nav-pills">
                  {menuData.map((item, index) => (
                    <li
                      className={item.children ? "dropdown" : ""}
                      key={`dropdown-${index}`}
                    >
                      {item.children ? (
                        <>
                          <SlideToggle collapsed={true}>
                            {({ onToggle, setCollapsibleElement }) => (
                              <>
                                <a
                                  href="#no"
                                  className="nav-link dropdown-toggle"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onToggle();
                                  }}
                                >
                                  {item.name}
                                  <i className="fas fa-caret-down"></i>
                                </a>

                                <ul
                                  className="dropdown-menu"
                                  ref={setCollapsibleElement}
                                >
                                  {item.children.map((subMenu, subId) => (
                                    <li
                                      className={
                                        subMenu.children
                                          ? "dropdown-submenu"
                                          : ""
                                      }
                                      key={`dropdown-${index}-${subId}`}
                                    >
                                      {subMenu.children ? (
                                        <SlideToggle collapsed={true}>
                                          {({
                                            onToggle,
                                            setCollapsibleElement,
                                          }) => (
                                            <>
                                              <a
                                                href="#no"
                                                className="nav-link dropdown-toggle"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  onToggle();
                                                }}
                                              >
                                                {subMenu.name}
                                                <i className="fas fa-caret-down"></i>
                                              </a>
                                              <ul
                                                className="dropdown-menu"
                                                ref={setCollapsibleElement}
                                              >
                                                {subMenu.children.map(
                                                  (ssubMenu, ssubId) => (
                                                    <li
                                                      key={`dropdown-${index}-${subId}-${ssubId}`}
                                                    >
                                                      <Link
                                                        to={
                                                          // process.env
                                                          //   .PUBLIC_URL +
                                                          ssubMenu.url
                                                        }
                                                        className="nav-link"
                                                      >
                                                        {ssubMenu.name}
                                                      </Link>
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </>
                                          )}
                                        </SlideToggle>
                                      ) : (
                                        <Link
                                          to={
                                            // process.env.PUBLIC_URL +
                                            subMenu.url
                                          }
                                          className="nav-link"
                                        >
                                          {subMenu.name}
                                        </Link>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              </>
                            )}
                          </SlideToggle>
                        </>
                      ) : (
                        <Link
                          to={
                            // process.env.PUBLIC_URL +
                            item.url
                          }
                          className="nav-link"
                        >
                          {item.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </Collapse>

        <div className="header-nav show d-none d-md-block">
          <div className="header-nav-main"></div>
        </div>
      </div>

      <div
        className="header-right"
        style={{
          position: "fixed",
          left: "20px",
          right: "initial",
          marginTop: "6px",
        }}
      >
        {/* <Button
          variant=""
          className="search-toggle d-none d-md-inline-block d-xl-none"
          onClick={() => toggleSearch(!search)}
        >
          <i className="bx bx-search"></i>
        </Button> */}
        {/* <Form
          action="#"
          className={`search search-style-1 nav-form d-none d-xl-inline-block ${
            search ? "active" : ""
          }`}
          onSubmit={prevent}
        >
          <InputGroup>
            <Form.Control
              type="text"
              className="form-control"
              placeholder="Search..."
            />
            <InputGroup.Append>
              <Button variant="default" type="submit">
                <i className="bx bx-search"></i>
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Form> */}

        {/* <span className="separator"></span> */}

        {/* <Dropdown className="d-none d-sm-block">
          <Dropdown.Toggle as="a" className="dropdown-language nav-link">
            <i className="flag flag-us"></i> EN
            <i className="fas fa-chevron-down"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu alignRight={true}>
            <Dropdown.Item>
              <i className="flag flag-us"></i> English
            </Dropdown.Item>
            <Dropdown.Item>
              <i className="flag flag-es"></i> Español
            </Dropdown.Item>
            <Dropdown.Item>
              <i className="flag flag-fr"></i> Française
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}

        {/* <span className="separator"></span> */}

        {/* <ul className="notifications">
          <li>
            <Dropdown>
              <Dropdown.Toggle as="a" className="notification-icon">
                <i className="bx bx-task"></i>
                <span className="badge">3</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="notification-menu large">
                <div className="notification-title">
                  <span className="float-right badge badge-default">3</span>{" "}
                  Tasks
                </div>

                <div className="content">
                  <ul>
                    <li>
                      <p className="clearfix mb-1">
                        <span className="message float-left">
                          Generating Sales Report
                        </span>
                        <span className="message float-right text-dark">
                          60%
                        </span>
                      </p>

                      <ProgressBar
                        className="progress-xs light"
                        min={0}
                        max={100}
                        now={60}
                      />
                    </li>

                    <li>
                      <p className="clearfix mb-1">
                        <span className="message float-left">
                          Importing Contacts
                        </span>
                        <span className="message float-right text-dark">
                          98%
                        </span>
                      </p>
                      <ProgressBar
                        className="progress-xs light"
                        min={0}
                        max={100}
                        now={98}
                      />
                    </li>

                    <li>
                      <p className="clearfix mb-1">
                        <span className="message float-left">
                          Uploading something big
                        </span>
                        <span className="message float-right text-dark">
                          33%
                        </span>
                      </p>
                      <ProgressBar
                        className="progress-xs light mb-1"
                        now={33}
                      />
                    </li>
                  </ul>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </li>
          <li>
            <Dropdown>
              <Dropdown.Toggle as="a" className="notification-icon">
                <i className="bx bx-envelope"></i>
                <span className="badge">4</span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="notification-menu">
                <div className="notification-title">
                  <span className="float-right badge badge-default">230</span>{" "}
                  Messages
                </div>

                <div className="content">
                  <ul>
                    <li>
                      <a href="#msg" className="clearfix" onClick={prevent}>
                        <span className="image image-as-text">JD</span>
                        <span className="title">Joseph Doe</span>
                        <span className="message">Lorem ipsum dolor sit.</span>
                      </a>
                    </li>
                    <li>
                      <a href="#msg" className="clearfix" onClick={prevent}>
                        <span className="image image-as-text bg-secondary">
                          JJ
                        </span>
                        <span className="title">Joseph Junior</span>
                        <span className="message truncate">
                          Truncated message. Lorem ipsum dolor sit amet,
                          consectetur adipiscing elit. Donec sit amet lacinia
                          orci. Proin vestibulum eget risus non luctus. Nunc
                          cursus lacinia lacinia. Nulla molestie malesuada est
                          ac tincidunt. Quisque eget convallis diam, nec
                          venenatis risus. Vestibulum blandit faucibus est et
                          malesuada. Sed interdum cursus dui nec venenatis.
                          Pellentesque non nisi lobortis, rutrum eros ut,
                          convallis nisi. Sed tellus turpis, dignissim sit amet
                          tristique quis, pretium id est. Sed aliquam diam diam,
                          sit amet faucibus tellus ultricies eu. Aliquam lacinia
                          nibh a metus bibendum, eu commodo eros commodo. Sed
                          commodo molestie elit, a molestie lacus porttitor id.
                          Donec facilisis varius sapien, ac fringilla velit
                          porttitor et. Nam tincidunt gravida dui, sed pharetra
                          odio pharetra nec. Duis consectetur venenatis
                          pharetra. Vestibulum egestas nisi quis elementum
                          elementum.
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#msg" className="clearfix" onClick={prevent}>
                        <span className="image image-as-text bg-tertiary">
                          MD
                        </span>
                        <span className="title">Monica Doe</span>
                        <span className="message">Lorem ipsum dolor sit.</span>
                      </a>
                    </li>
                    <li>
                      <a href="#msg" className="clearfix" onClick={prevent}>
                        <span className="image image-as-text bg-quaternary">
                          RD
                        </span>
                        <span className="title">Robert Doe</span>
                        <span className="message">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Donec sit amet lacinia orci. Proin vestibulum
                          eget risus non luctus. Nunc cursus lacinia lacinia.
                          Nulla molestie malesuada est ac tincidunt. Quisque
                          eget convallis diam.
                        </span>
                      </a>
                    </li>
                  </ul>

                  <hr />

                  <div className="text-right">
                    <a href="#msg" className="view-more" onClick={prevent}>
                      View All
                    </a>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </li>
          <li>
            <Dropdown>
              <Dropdown.Toggle as="a" className="notification-icon">
                <i className="bx bx-bell"></i>
                <span className="badge">3</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="notification-menu">
                <div className="notification-title">
                  <span className="float-right badge badge-default">3</span>{" "}
                  Alerts
                </div>

                <div className="content">
                  <ul>
                    <li>
                      <a href="#log" className="clearfix" onClick={prevent}>
                        <div className="image">
                          <i className="bx bx-dislike bg-danger"></i>
                        </div>
                        <span className="title">Server is Down!</span>
                        <span className="message">Just now</span>
                      </a>
                    </li>
                    <li>
                      <a href="#log" className="clearfix" onClick={prevent}>
                        <div className="image">
                          <i className="bx bx-lock-alt bg-warning"></i>
                        </div>
                        <span className="title">User Locked</span>
                        <span className="message">15 minutes ago</span>
                      </a>
                    </li>
                    <li>
                      <a href="#log" className="clearfix" onClick={prevent}>
                        <div className="image">
                          <i className="bx bx-wifi bg-success"></i>
                        </div>
                        <span className="title">Connection Restaured</span>
                        <span className="message">10/10/2017</span>
                      </a>
                    </li>
                  </ul>

                  <hr />

                  <div className="text-right">
                    <Link
                      to={`${process.env.PUBLIC_URL}/pages/log-viewer`}
                      className="view-more"
                    >
                      View All
                    </Link>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </li>
        </ul> */}

        {/* <span className="separator"></span> */}
        {/* <Link to={`/EditProfile`}> */}
        {/* <div id="userbox" className={`userbox ${showUserBox ? "show" : ""}`}>
            <img
              src={props.ProfileImg}
              style={{ borderRadius: "50%", height: "50px", width: "50px" }}
            />
            <div
              className="profile-info profile-info-no-role"
              style={{ direction: "rtl", marginTop: "3px" }}
            >
              <span className="name">
                <strong className="font-weight-semibold">
                  {props.accountName}
                </strong>
              </span>
            </div>
            <i className="fas fa-chevron-down text-color-dark"></i>

            <div className={`dropdown-menu ${showUserBox ? "show" : ""}`}>
            <ul className="list-unstyled">
              <li>
                <Link to={`/pages/user-profile`}>
                  <i className="bx bx-user"></i> My Profile
                </Link>
              </li>
              <li>
                <Link to={`                /pages/sign-in`}>
                  <i className="bx bx-log-out"></i> Logout
                </Link>
              </li>
            </ul>
          </div>
          </div> */}

        {/* <div id="userbox" className={`userbox ${showUserBox ? "show" : ""}`}>
          <a href="#no" onClick={onToggleUserBox}>
            <span className="profile-picture ">
              {" "}
              <img
                src={props.ProfileImg}
                style={{ borderRadius: "50%", height: "50px", width: "50px" }}
              />
            </span>
            <div className="profile-info profile-info-no-role">
              <span className="name">
                سلام,{" "}
                <strong className="font-weight-semibold">
                  {props.accountName}
                </strong>
              </span>
            </div>
            <i className="fas fa-chevron-down text-color-dark"></i>
          </a>

          <div className={`dropdown-menu ${showUserBox ? "show" : ""}`}>
            <ul className="list-unstyled" style={{ textAlign: "right" }}>
              <li>
                <Link to={`/EditProfile`}>
                  پروفایل <i className="bx bx-user"></i>{" "}
                </Link>
              </li>
              <li>
                <Link to={`/ChangePassword`}>
                  {" "}
                  تغییر رمز عبور<i className="bx bxs-key"></i>
                </Link>
              </li>
              <li>
                <Link to={`/signup`}>
                  خروج<i className="bx bx-log-out"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div> */}

        <div id="userbox" className={`userbox ${showUserBox ? "show" : ""}`}>
          <a href="#no" onClick={onToggleUserBox}>
            <span className="profile-picture ">
              {" "}
              <img
                src={
                  "data:image/png;base64,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"
                }
                style={{ borderRadius: "50%", height: "50px", width: "50px" }}
              />
            </span>
            <div className="profile-info profile-info-no-role">
              <span className="name">
                {" "}
                <strong className="font-weight-semibold">ادمین</strong>
              </span>
            </div>
            <i className="fas fa-chevron-down text-color-dark"></i>
          </a>

          <div className={`dropdown-menu ${showUserBox ? "show" : ""}`}>
            <ul className="list-unstyled" style={{ textAlign: "right" }}>
              {/* <li onClick={onToggleUserBox}>
                <Link to={`/EditProfile`}>
                  پروفایل <i className="bx bx-user"></i>{" "}
                </Link>
              </li> */}
              <li onClick={onToggleUserBox}>
                <Link to={`/ChangePassword`}>
                  {" "}
                  تغییر رمز عبور<i className="bx bxs-key"></i>
                </Link>
              </li>
              <li onClick={onToggleUserBox}>
                <Link to={`/signup`}>
                  خروج<i className="bx bx-log-out"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* </Link> */}
      </div>
    </header>
  );
}
